<template>
	<div>
		<titlebar :title="$route.name" />
		<router-view />
	</div>
</template>

<script>
import Titlebar from '@/components/admin/Titlebar'
export default {
	name: 'campaigns',
	components: {
		Titlebar
	}
}
</script>
